import React from "react";
import "./images.css";
import { McIcon } from "@maersk-global/mds-react-wrapper/components-core";

function UploadedImages({ images, previewImage, deleteImage, deleteImageFor, error }) {
  if (!images) return null;

  if (error) {
    return (
      <p style={{ fontSize: "12px", color: "var(--mds_brand_appearance_error_default_text-color, #c0392b)", margin: "4px 0 0" }}>
        Error fetching images — please contact admin
      </p>
    );
  }

  if (images.length === 0) return null;

  const handleDeleteClick = (image) => {
    const confirmed = window.confirm(`Are you sure you want to delete "${image.name}"?`);
    if (confirmed) {
      deleteImage(image, deleteImageFor);
    }
  };

  return (
    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
      {images.map((image, index) => (
        <div
          key={image.name || `image-${index}`}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "4px 10px",
            border: "1px solid var(--mds_brand_appearance_default_border-color, #e0e0e0)",
            borderRadius: "var(--mds_brand_border_medium_radius, 4px)",
            background: "var(--mds_brand_appearance_neutral_weakest_background-color, #fff)",
            fontSize: "12px",
            color: "var(--mds_brand_appearance_default_default_text-color, #141414)",
            maxWidth: "280px",
            minWidth: "150px",
          }}
        >
          <McIcon icon="image" size="14" style={{ flexShrink: 0 }} />
          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1, minWidth: "60px" }}>
            {image.name}
          </span>
          <button
            onClick={() => previewImage(image)}
            title="Preview image"
            style={{ 
              background: "none", 
              border: "none", 
              cursor: "pointer", 
              padding: "4px", 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "center",
              color: "var(--mds_brand_appearance_primary_default_text-color, #0073ab)",
              flexShrink: 0,
              borderRadius: "2px",
              transition: "background-color 0.2s"
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = "rgba(0, 115, 171, 0.1)"}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = "transparent"}
          >
            <McIcon icon="eye" size="16" />
          </button>
          <button
            onClick={() => handleDeleteClick(image)}
            title="Delete image"
            style={{ 
              background: "none", 
              border: "none", 
              cursor: "pointer", 
              padding: "4px", 
              display: "flex", 
              alignItems: "center", 
              justifyContent: "center",
              color: "var(--mds_brand_appearance_error_default_text-color, #c0392b)",
              flexShrink: 0,
              borderRadius: "2px",
              transition: "background-color 0.2s"
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = "rgba(192, 57, 43, 0.1)"}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = "transparent"}
          >
            <McIcon icon="trash" size="16" />
          </button>
        </div>
      ))}
    </div>
  );
}

export default UploadedImages;
